import React, { createElement } from "react";
import Storyblok, { version } from "@/lib/storyblok-client";
import { relationsToResolve } from "@/constants/general";
import {
  GetRandomCoaches,
  getCurrentPaths,
  getRandomCoaches,
} from "@/lib/storyblok-gapi";
import Components from "../../components/components";
import { getSeoFromStory } from "@/lib/seo";
import { useStoryblok } from "../../helpers/storyblok-hook";
import { isProduction } from "../../helpers/environment";
import { Story } from "@/types/storyblok";
import { GetStaticPropsContext } from "next";

interface Props {
  story?: Story;
  coaches: GetRandomCoaches;
}

export default function Coach({ story, coaches }: Props) {
  story = useStoryblok(story, !isProduction);

  return (
    story &&
    createElement(Components(story?.content?.component), {
      key: story?.uuid,
      content: story?.content,
      published: story.published_at,
      coaches,
      id: story?.id,
      name: story?.name,
    })
  );
}

export async function getStaticPaths() {
  const {
    CoachItems: { items },
  } = await getCurrentPaths({ name: "CoachItems" });

  const paths = items.map((item) => ({ params: { slug: item.slug } }));

  return {
    paths,
    fallback: "blocking",
  };
}

export async function getStaticProps(context: GetStaticPropsContext) {
  const { params: { slug } = { slug: "" } } = context;

  try {
    const {
      data: { story },
    } = await Storyblok.get(`cdn/stories/coaches/${slug}`, {
      resolve_relations: relationsToResolve,
      version,
    });
    const coaches = (await getRandomCoaches(4)) || [];

    return {
      props: {
        story,
        coaches,
        seo: await getSeoFromStory({ story }),
        revalidate: 86400,
      },
    };
  } catch (error) {
    console.log(error);
    return {
      notFound: true,
    };
  }
}
